export const enhancer = el => {
  el.addEventListener('click', e => {
    el.nextSibling.classList.remove('text-collapser__read-more-full-text--hidden');
    el.remove();
  });
};
